import xmlFormatter from '../../../_virtual/index.js';

const CodeUtils = {
  format(code) {
    return xmlFormatter(code, {
      indentation: "  ",
      collapseContent: false,
      lineSeparator: "\n",
      whiteSpaceAtEndOfSelfclosingTag: false
    });
  }
};

export { CodeUtils };
//# sourceMappingURL=code-utils.js.map
